import * as types from "./mutation-types";
import { getRequestTypesQuery } from "./queries.graphql";
import api from "@/modules/api";
import gqlClient from "@/modules/graphql";

const actions = {
  async getRequestTypes({ commit, rootState }) {
    try {
      commit(types.GET_REQUESTTYPES_BEGIN);
      const {
        data: { data }
      } = await gqlClient.query(
        {
          query     : getRequestTypesQuery,
          variables : { storeId : rootState.app.Store.id }
        },
        { timeout : 60000 }
      );
      commit(types.GET_REQUESTTYPES_SUCCESS, data.store.requestTypes);
    } catch (e) {
      commit(types.GET_REQUESTTYPES_ERROR, e);
    }
  },

  async deleteRequestType({ commit }, id) {
    try {
      commit(types.DELETE_REQUESTTYPE_BEGIN);
      await api.requestType.deleteRequestType(id);
      commit(types.DELETE_REQUESTTYPE_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_REQUESTTYPE_ERROR, e);
    }
  },
  async createRequestType({ commit }, variables) {
    try {
      commit(types.CREATE_REQUESTTYPE_BEGIN);
      const { data }=await api.requestType.addRequestType(variables);
      commit(types.CREATE_REQUESTTYPE_SUCCESS, data);
    } catch (e) {
      commit(types.CREATE_REQUESTTYPE_ERROR, e);
    }
  },

  async updateRequestType({ commit }, { id,data }) {
    try {
      commit(types.UPDATE_REQUESTTYPE_BEGIN);
      const { data:updateData }= await api.requestType.updateRequestType(id,data);
      commit(types.UPDATE_REQUESTTYPE_SUCCESS, updateData);
    } catch (e) {
      commit(types.UPDATE_REQUESTTYPE_ERROR, e);
    }
  },
};

export default actions;
